import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    PatientForListResponse,
    GetPatientLocalSearchListQuery,
    ComboboxItemDtoOfLong,
    PatientsServiceProxy
} from '../../../../shared/service-proxies/service-proxies';


@Component({
    templateUrl: 'busquedapacientes-locales-grid.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class BusquedaPacientesLocalesGridComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    data: PatientForListResponse[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;
    query: GetPatientLocalSearchListQuery = new GetPatientLocalSearchListQuery();

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private service: PatientsServiceProxy

    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.cols = [
            { field: 'id', header: this.l('Catalogos.Patients.Id.Col'), isActive: true },
            { field: 'fullName', header: this.l('Catalogos.Patients.FullName.Col'), isActive: true },
            { field: 'NSS', header: this.l('Catalogos.Patients.NSS.Col'), isActive: true },
            { field: 'sexDesc', header: this.l('Catalogos.Patients.Sex.Col'), isActive: true },
            { field: 'patientTypeImssDesc', header: this.l('Catalogos.Patients.PatientTypeImss.Col'), isActive: true },
            { field: 'medicalAttache', header: this.l('Catalogos.Patients.MedicalAttache.Col'), isActive: true },
            { field: 'IDEE', header: this.l('Catalogos.Patients.IDEE.Col'), isActive: true },
            {
                field: 'isActive',
                header: self.l('IsActive'),
                width: '100px',
                isActive: true
            }
        ];

        self.form = self.formBuilder.group({
            filterText: [null]
        });

        self.query = new GetPatientLocalSearchListQuery();
        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }

    getList(): void {
        const self = this;

        self.query.filter = self.f.filterText.value;
        self.blockedDocument = true;

        self.service.getPatientsLocalSearchList(self.query)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.data = data.items;

                // Calculate paged table summary
                self.pagedTableSummary = self.getPagedTableSummay(data.totalCount, self.query.pageNumber, self.query.pageSize);
            });
    }

    loadData(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.query.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.query.sorting = '';
        }

        self.query.pageNumber = 1 + (event.first / event.rows);
        self.query.pageSize = event.rows;

        self.getList();
    }

    filterSearch($event): void {
        const self = this;

        $event.preventDefault();

        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }

    seleccionar(rowData: PatientForListResponse): void {
        const self = this;

        self.close(rowData);
    }


    close(seleccionado: PatientForListResponse): void {
        const self = this;

        self.modalRef.close(seleccionado);
    }
}
